export const shopware6 = {
  clientId: "Access ID",
  clientSecret: "Security key",
  clientIdHelp:
    'You can find the access ID in the Shopware 6 backend under "Settings > System > Integrations".',
  clientSecretHelp:
    'The security key can be viewed in the Shopware 6 backend under "Settings > System > Integrations". Please note that the security key is only displayed when the integration is created.'
};
